import { render, staticRenderFns } from "./customercall.vue?vue&type=template&id=8b7f3784"
import script from "./customercall.vue?vue&type=script&lang=js"
export * from "./customercall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports